<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import moment from 'moment'
export default
{
    name: 'mv-ticket-form',

    computed:
    {
        ...mapGetters({
            locale: 'generalCurrentLocale',
        }),

    },

    methods:
    {
        save()
        {
            this.$emit('save')
        },

        submit()
        {
            this.$refs.form.submit()
        },

        addFile(file)
        {
            this.model.attachments.push(file)
        },

        removeFile(file)
        {
            for (let i = 0; i < this.model.attachments.length; ++i)
            {
                const item = this.model.attachments[i]
                if (file.id == item.id)
                {
                    this.model.attachments.splice(i, 1)
                }
            }

        },

        removePrice(price)
        {
          this.model.ticket_prices.splice(this.model.ticket_prices.findIndex(el => el.id === price.id), 1)
        },

        addPrice()
        {
          const sorted = JSON.parse(JSON.stringify(this.model.ticket_prices)).sort((a,b) => {
            return - (a.id - b.id)
          })
          let id = 99
          if (sorted && sorted[0]) id = sorted[0].id
          id++
          this.model.ticket_prices.push({
            id: id,
            new: true,
            date_from: moment().subtract(1, 'month').format('YYYY-MM-DD'),
            date_to: moment().format('YYYY-MM-DD'),
            price: 5000,
          })
        },

        parseDate(date)
        {
          return moment(date).format('YYYY-MM-DD')
        }
    },

    props:
    {
        model: Object,
        edit: Boolean,
    },

    data()
    {
        return {
            editPrice: null,
            newDate: moment(),
            types: [
              {
                id: 'mainpage',
                name: 'Fő oldal',
              },
              {
                id: 'ticket',
                name: 'Jegy',
              },
              {
                id: 'accommodation',
                name: 'Szállás',
              },
            ]
        }
    }

}
</script>

<template>
<div class="container">
    <form @submit.prevent.stop="save" ref="form">
        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.TITLE') }}
            </label>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon1">
                        <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.text">
                </div>
            </div>
            <div class="col-md-3">
                <div class="input-group">
                    <span class="input-group-addon" id="basic-addon2">
                        <img src="/static/us-flag.png" alt="English" title="English" height="20">
                    </span>
                    <input type="text" class="form-control" v-model="model.text_en" >
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                Sorrend
            </label>
            <div class="col-md-6">
                <div class="input-group">
                    <input class="form-control" v-model="model.order" type="number">
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('PLACE.TYPE') }}
            </label>
            <div class="col-md-6">
                <div class="input-group">
                    <select name="type" v-model="model.type" class="form-control">
                        <option :value="item.id" v-for="item in types" :key="item.id" >
                            {{ item.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                Kiemenlt
            </label>
            <div class="col-md-6">
                <div class="input-group">
                    <input v-model="model.is_top" type="checkbox">
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.TEXT') }}
                <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
            </label>
            <div class="col-md-8">
                <textarea v-model="model.body" class="form-control" rows="4">

                </textarea>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.TEXT') }}
                <img src="/static/us-flag.png" alt="Magyar" title="Magyar" height="20">
            </label>
            <div class="col-md-8">
                <textarea v-model="model.body_en" class="form-control" rows="4">

                </textarea>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                Korlátozások
                <img src="/static/hu-flag.png" alt="Magyar" title="Magyar" height="20">
            </label>
            <div class="col-md-8">
                <input type="text" v-model="model.limitations" class="form-control" rows="4">
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                Korlátozások
                <img src="/static/us-flag.png" alt="Magyar" title="Magyar" height="20">
            </label>
            <div class="col-md-8">
                <input type="text" v-model="model.limitations_en" class="form-control" rows="4">
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.DATE') }}
            </label>
            <div class="col-md-6">
                <div class="row">
                  <div class="col-md-12" v-if="!model.date">
                    <button class="btn btn-sm btn-primary" @click.stop.prevent="model.date = newDate">+</button>
                  </div>
                  <div class="col-md-10" v-if="model.date">
                    <mv-date-time-picker only-date v-model="model.date"></mv-date-time-picker>
                  </div>
                  <div class="col-md-2" v-if="model.date">
                    <button class="btn btn-sm btn-danger" @click.stop.prevent="model.date = null">X</button>
                  </div>
                </div>
            </div>
        </div>


        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                Ár
            </label>
            <div class="col-md-6">
                <div class="input-group">
                    <input class="form-control" v-model="model.price" type="number">
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                Eredeti Ár
            </label>
            <div class="col-md-6">
                <div class="input-group">
                    <input class="form-control" v-model="model.price_old" type="number">
                </div>
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                {{ $t('GENERAL.LINK') }}
            </label>
            <div class="col-md-6">
                <input type="text" class="form-control" v-model="model.tixa_url">
            </div>
        </div>

        <div class="form-group row">
            <label for="name" class="col-md-4 control-label">
                Új fülön?
            </label>
            <div class="col-md-6">
                <input type="checkbox" v-model="model.is_new_tab">
            </div>
        </div>

        <div class="form-group row" v-if="model && model.ticket_prices && model.id">
            <label for="name" class="col-md-4 control-label">
                Időszakos Árak
            </label>
            <div class="col-md-6">
              <table class="table" style="margin-top: .5em;">
                <tr>
                  <th style="padding: .5em 0;">Mettől</th>
                  <th style="padding: .5em 0;">Meddig</th>
                  <th style="padding: .5em 0;">Ár (HUF)</th>
                  <th style="padding: .5em 0;">
                    <button type="button" class="btn btn-primary btn-sm" @click="addPrice()">
                        <icon name="plus"></icon>
                    </button>
                  </th>
                </tr>
                <tr v-for="price in model.ticket_prices" :key="price.id" style="padding: .5em 0;">
                  <td style="padding: .5em .5em;">
                    <input class="form-control" type="date" :value="parseDate(price.date_from)" @input="price.date_from = $event.target.value">
                  </td>
                  <td style="padding: .5em .5em;">
                    <input class="form-control" type="date" :value="parseDate(price.date_to)" @input="price.date_to = $event.target.value">
                  </td>
                  <td style="padding: .5em .5em;">
                    <input class="form-control" type="number" min="0" max="1000000" v-model="price.price">
                  </td>
                  <td>
                    <button type="button" class="btn btn-danger btn-sm" @click="removePrice(price)">
                        <icon name="trash"></icon>
                    </button>
                  </td>
                </tr>
              </table>
            </div>
        </div>
    </form>
</div>
</template>



// WEBPACK FOOTER //
// src/components/forms/TicketForm.vue